// extracted by mini-css-extract-plugin
export default {"page":"iJ","top_block":"jJ","heading":"kJ","inner_text":"lJ","starter_text":"mJ","starter_cta":"nJ","summary_block":"oJ","cartsummary_wrap":"pJ","price":"qJ","pricing_wrap":"rJ","summary_block_mob":"sJ","summary":"tJ","pricing_heading":"uJ","products_summary":"vJ","summary_line":"wJ","summary_price":"xJ","summary_title":"yJ"};
    if(module.hot) {
      // 1714654894031
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  